import { Link, useNavigate } from "react-router-dom";
import { LogOut, Star, User as UserIcon, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/contexts/AuthContext";

/** Sign-in link when logged out; avatar menu when logged in. */
export const AccountMenu = ({ onNavigate }: { onNavigate?: () => void }) => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  if (!user) {
    return (
      <Button asChild variant="ghost" size="sm" className="h-8 px-2.5 text-sm">
        <Link to="/auth" onClick={onNavigate}>
          Sign in
        </Link>
      </Button>
    );
  }

  const initial = (user.email ?? "?").charAt(0).toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label="Account menu"
          className="h-8 w-8 rounded-full bg-primary/15 text-primary font-bold text-sm flex items-center justify-center border border-primary/30 hover:bg-primary/25 transition-colors"
        >
          {initial}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 bg-popover z-50">
        <DropdownMenuLabel className="truncate text-xs font-normal text-muted-foreground">
          {user.email}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => { onNavigate?.(); navigate("/portfolio"); }}>
          <Wallet className="w-4 h-4 mr-2" /> My Portfolio
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => { onNavigate?.(); navigate("/watchlist"); }}>
          <Star className="w-4 h-4 mr-2" /> My Watchlist
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => { onNavigate?.(); navigate("/account"); }}>
          <UserIcon className="w-4 h-4 mr-2" /> Account
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={async () => {
            onNavigate?.();
            await signOut();
            navigate("/");
          }}
        >
          <LogOut className="w-4 h-4 mr-2" /> Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AccountMenu;
